<template>
  <div id="wrapper">
      <!-- ヘッダの表示 -->
      <page-header />
      <!-- メイン部分の表示 -->
      <!-- <page-main /> -->
      <!--PageMainコンポーネントが表示される領域-->
      <router-view></router-view>
  </div>
</template>

<script>
//ref関数を使えるようにする 今は必要ない
// import {ref} from 'vue';

//使用するコンポーネントの読み込み
import PageHeader from './components/PageHeader.vue';
// import PageMain from './components/PageMain.vue';

// 状態管理追記
import { provide } from 'vue';
import katudoTouroku from './store/katudo_touroku';
import katudoMosikomi from './store/katudo_mosikomi';
import LoginStates from './store/login_state';
// import SearchInfo from './store/search_info';
// import ModalYoko from './store/modal_yoko';

export default {
  //名前をつける（あとあと利用することがあれば参照しやすいように？）単一ファイルコンポーネントでは必須ではないらしい。nameがなければファイル名がそのままコンポーネント名になる。
  name: 'App',
  //読み込んだコンポーネントを使えるようにする
  components: {
    PageHeader,
    // PageMain,
  },
  setup () {
	provide('ktouroku', katudoTouroku())
	provide('kmosikomi', katudoMosikomi())
	provide('loginstate', LoginStates())
	// provide('searchinfo', SearchInfo())
	// provide('modalyoko', ModalYoko())
	return {}
  },
  // ページタイトル変更
	methods: {
		createTitle : function(routeInstance){
			if(routeInstance.meta.title){
				let setTitle = routeInstance.meta.title + '｜青森市ボランティアセンター';
				document.title = setTitle;
			} else {
				document.title = '体験ボランティア｜青森市ボランティアセンター';
			}
		}
	},
	mounted: function() {
		let routeInstance = this.$route;
		this.createTitle(routeInstance);
	},
	watch: {
		'$route' (routeInstance) {
			// console.log(from)
			this.createTitle(routeInstance);
		}
	}
};

</script>

<style>

</style>